<template>

</template>
<script>
export default {
  props: {src: String, callBack: Function},
  created: function () {
    let self = this

    var load_script = function () {
      return new Promise((resolve, reject) => {
        let script = document.createElement('script')
        script.setAttribute('src', self.$props.src)
        script.async = true

        script.onload = function () {
          self.$props.callBack()
          resolve()
        }
        document.head.appendChild(script)
      })
    }
    load_script()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ScriptLoader.vue